import { render, staticRenderFns } from "./HefriasLinks.vue?vue&type=template&id=64b17585&scoped=true&"
import script from "./HefriasLinks.vue?vue&type=script&lang=js&"
export * from "./HefriasLinks.vue?vue&type=script&lang=js&"
import style0 from "./HefriasLinks.vue?vue&type=style&index=0&id=64b17585&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b17585",
  null
  
)

export default component.exports